import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import type { Shop } from "@/api";
import { ChevronDownStrokeIcon, StarIcon, XIcon } from "@/components/icons";
import { Button } from "@/components/ui/button";
import { Chip } from "@/components/ui/chip";
import { Sheet, SheetClose, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { cn } from "@/lib/utils";

// Панель «Информация о магазине» (Figma 3870:52973): шторка 610 у левого края
// на всю высоту поверх затемнения — та же схема, что «Все фильтры» каталога
// (в кадре затемнение #000 20 %, у шторки DS — общее для всех шторок). Чипы «О магазине» / «Доставка и гарантия», карточка средней оценки,
// ряд статов, блок «О бренде» и сертификаты. Данные — из Shop и категорий
// витрины; полей, которых нет на бэкенде (продажи, подписчики, сертификаты,
// реквизиты ЮЛ), не выдумываем — показываем пустое состояние.
export function ShopInfoModal(t0) {
  const $ = _c(41);
  const {
    open,
    onOpenChange,
    shop,
    categories
  } = t0;
  const {
    t
  } = useTranslation();
  const [tab, setTab] = useState("about");
  const [expanded, setExpanded] = useState(false);
  let t1;
  if ($[0] !== t) {
    t1 = t("shop.info.title", {
      defaultValue: "\u0418\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F"
    });
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <SheetTitle className="ds-h3 text-ds-ink-2">{t1}</SheetTitle>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t("common.close");
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <XIcon />;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3) {
    t5 = <SheetClose aria-label={t3} className="flex size-6 shrink-0 items-center justify-center rounded-[4px] text-ds-ink-3 outline-none focus-visible:ring-2 focus-visible:ring-ds-focus">{t4}</SheetClose>;
    $[7] = t3;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t2 || $[10] !== t5) {
    t6 = <SheetHeader className="flex-row items-center justify-between gap-6 pt-[30px] pr-5 pb-2.5 pl-[30px]">{t2}{t5}</SheetHeader>;
    $[9] = t2;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const t7 = tab === "about";
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => setTab("about");
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t) {
    t9 = t("shop.info.aboutTab", {
      defaultValue: "\u041E \u043C\u0430\u0433\u0430\u0437\u0438\u043D\u0435"
    });
    $[13] = t;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t7 || $[16] !== t9) {
    t10 = <Chip size="md" selected={t7} onClick={t8}>{t9}</Chip>;
    $[15] = t7;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  const t11 = tab === "delivery";
  let t12;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = () => setTab("delivery");
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== t) {
    t13 = t("shop.info.deliveryTab", {
      defaultValue: "\u0414\u043E\u0441\u0442\u0430\u0432\u043A\u0430 \u0438 \u0433\u0430\u0440\u0430\u043D\u0442\u0438\u044F"
    });
    $[19] = t;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== t11 || $[22] !== t13) {
    t14 = <Chip size="md" selected={t11} onClick={t12}>{t13}</Chip>;
    $[21] = t11;
    $[22] = t13;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== t10 || $[25] !== t14) {
    t15 = <div className="flex flex-wrap items-center gap-2.5 py-2.5 pr-5 pl-[30px]">{t10}{t14}</div>;
    $[24] = t10;
    $[25] = t14;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== categories || $[28] !== expanded || $[29] !== shop || $[30] !== t || $[31] !== tab) {
    t16 = tab === "about" ? <div className="flex flex-col"><h3 className="py-2.5 pr-5 pl-[30px] text-[20px] leading-6 font-bold tracking-[-0.6px] text-ds-ink">{shop.name}</h3>{categories.length > 0 && <div className="flex flex-wrap gap-2 pt-1 pr-5 pb-2 pl-[30px]">{categories.map(_temp)}</div>}<Block><div className="flex flex-col gap-5 rounded-[16px] bg-ds-quaternary p-2.5"><div className="flex items-center gap-3"><span className="flex h-[43px] w-[67px] shrink-0 items-center justify-center gap-1 rounded-[14px] bg-ds-accent text-[20px] leading-[27px] font-semibold tracking-[-0.4px] text-white"><StarIcon size={18} />{shop.rating.toFixed(1)}</span><div className="flex flex-col gap-2"><span className="text-[16px] leading-5 font-medium tracking-[-0.31px] text-black">{t("shop.info.avgRating", {
                  defaultValue: "\u0421\u0440\u0435\u0434\u043D\u044F\u044F \u043E\u0446\u0435\u043D\u043A\u0430 \u0442\u043E\u0432\u0430\u0440\u043E\u0432"
                })}</span><span className="ds-t3 text-ds-ink">{t("shop.info.basedOn", {
                  defaultValue: "\u041D\u0430 \u043E\u0441\u043D\u043E\u0432\u0435 {{count}} \u043E\u0446\u0435\u043D\u043E\u043A",
                  count: shop.ratingCount
                })}</span></div></div><div className="flex flex-col"><InfoRow label={t("shop.info.country", {
              defaultValue: "\u0421\u0442\u0440\u0430\u043D\u0430"
            })} value={shop.location} /><InfoRow label={t("shop.info.onPlatform", {
              defaultValue: "\u041D\u0430 \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0435"
            })} value={t("shop.info.since", {
              defaultValue: "\u0441 {{year}}",
              year: shop.since
            })} last={true} /></div></div></Block><Block><div className="grid grid-cols-3 rounded-[16px] bg-ds-quaternary px-3 py-4"><Stat label={t("shop.info.sales", {
            defaultValue: "\u041F\u0440\u043E\u0434\u0430\u0436\u0438"
          })} value={"\u2014"} /><Stat label={t("shop.info.subscribers", {
            defaultValue: "\u041F\u043E\u0434\u043F\u0438\u0441\u0447\u0438\u043A\u0438"
          })} value={"\u2014"} /><Stat label={t("shop.info.reviews", {
            defaultValue: "\u041E\u0442\u0437\u044B\u0432\u044B"
          })} value={String(shop.ratingCount)} /></div></Block>{shop.description && <Block><div className="flex flex-col gap-3.5 rounded-[12px] bg-ds-quaternary p-2.5"><div className="flex flex-col gap-2"><h4 className="text-[16px] leading-[22px] font-bold text-ds-primary">{t("shop.info.aboutBrand", {
                defaultValue: "\u041E \u0431\u0440\u0435\u043D\u0434\u0435"
              })}</h4><p className={cn("text-[14px] leading-5 font-medium whitespace-pre-line text-ds-primary", !expanded && "line-clamp-3")}>{shop.description}</p></div><Button variant="gray" size="md" block={true} onClick={() => setExpanded(_temp2)}>{expanded ? t("shop.info.showLess", {
              defaultValue: "\u0421\u0432\u0435\u0440\u043D\u0443\u0442\u044C"
            }) : t("shop.info.showMore", {
              defaultValue: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0435\u0449\u0435"
            })}<ChevronDownStrokeIcon className={cn("transition-transform", expanded && "rotate-180")} /></Button></div></Block>}<Block><div className="flex flex-col gap-4 rounded-[16px] bg-ds-quaternary p-2.5"><h4 className="text-[16px] leading-[22px] font-bold text-ds-primary">{t("shop.info.certificates", {
              defaultValue: "\u0421\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u044B \u043F\u043E\u0434\u043B\u0438\u043D\u043D\u043E\u0441\u0442\u0438"
            })}</h4><p className="py-2 text-center ds-t3 text-ds-muted">{t("shop.info.noCertificates", {
              defaultValue: "\u0421\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u044B \u043F\u043E\u043A\u0430 \u043D\u0435 \u0437\u0430\u0433\u0440\u0443\u0436\u0435\u043D\u044B"
            })}</p></div></Block><Block><div className="rounded-[12px] bg-ds-quaternary p-2.5 text-center ds-t4 text-ds-muted">{t("shop.info.noRequisites", {
            defaultValue: "\u0420\u0435\u043A\u0432\u0438\u0437\u0438\u0442\u044B \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0430 \u043F\u043E\u044F\u0432\u044F\u0442\u0441\u044F \u043F\u043E\u0437\u0436\u0435"
          })}</div></Block></div> : <div className="flex flex-col"><Block><div className="flex flex-col gap-2 rounded-[16px] bg-ds-quaternary p-2.5"><h4 className="text-[16px] leading-[22px] font-bold text-ds-primary">{t("shop.deliveryTab.guaranteesTitle", {
              defaultValue: "\u0413\u0430\u0440\u0430\u043D\u0442\u0438\u0438"
            })}</h4><p className="text-[14px] leading-5 font-medium text-ds-primary">{t("shop.deliveryTab.guaranteesBody", {
              defaultValue: "\u0412\u043E\u0437\u0432\u0440\u0430\u0442 \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0435 14 \u0434\u043D\u0435\u0439. \u0422\u043E\u0432\u0430\u0440\u044B \u0440\u0443\u0447\u043D\u043E\u0439 \u0440\u0430\u0431\u043E\u0442\u044B \u0438 \u043F\u043E\u0434 \u0437\u0430\u043A\u0430\u0437 \u2014 \u043F\u043E \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u043C \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0430."
            })}</p></div></Block><Block><div className="flex flex-col gap-2 rounded-[16px] bg-ds-quaternary p-2.5"><h4 className="text-[16px] leading-[22px] font-bold text-ds-primary">{t("shop.deliveryTab.deliveryTitle", {
              defaultValue: "\u0414\u043E\u0441\u0442\u0430\u0432\u043A\u0430"
            })}</h4><p className="text-[14px] leading-5 font-medium text-ds-primary">{t("shop.deliveryTab.standard", {
              defaultValue: "\u0421\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u0430\u044F \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0430 \u2014 3\u20137 \u0434\u043D\u0435\u0439."
            })}</p><p className="text-[14px] leading-5 font-medium text-ds-primary">{t("shop.deliveryTab.express", {
              defaultValue: "\u042D\u043A\u0441\u043F\u0440\u0435\u0441\u0441 \u2014 1\u20132 \u0434\u043D\u044F."
            })}</p></div></Block></div>;
    $[27] = categories;
    $[28] = expanded;
    $[29] = shop;
    $[30] = t;
    $[31] = tab;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== t15 || $[34] !== t16 || $[35] !== t6) {
    t17 = <SheetContent side="left" showCloseButton={false} className="w-full gap-0 overflow-y-auto border-0 bg-white p-0 pb-2.5 shadow-none sm:max-w-[610px]">{t6}{t15}{t16}</SheetContent>;
    $[33] = t15;
    $[34] = t16;
    $[35] = t6;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== onOpenChange || $[38] !== open || $[39] !== t17) {
    t18 = <Sheet open={open} onOpenChange={onOpenChange}>{t17}</Sheet>;
    $[37] = onOpenChange;
    $[38] = open;
    $[39] = t17;
    $[40] = t18;
  } else {
    t18 = $[40];
  }
  return t18;
}

/** Блок панели: поля 10/20/10/30, как у «infoBlock» в кадре. */
function _temp2(v) {
  return !v;
}
function _temp(c) {
  return <span key={c} className="inline-flex h-6 items-center rounded-full bg-[#F5F5F5] px-2 text-[12px] leading-4 font-medium text-[#565656]">{c}</span>;
}
function Block(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <div className="py-2.5 pr-5 pl-[30px]">{children}</div>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}

// Figma: строка 20, подпись 12/18 w400 #161616, значение 14/20 w600 #000 справа.
function InfoRow(t0) {
  const $ = _c(10);
  const {
    label,
    value,
    last
  } = t0;
  const t1 = !last && "border-b border-ds-tertiary";
  let t2;
  if ($[0] !== t1) {
    t2 = cn("flex items-center justify-between py-2.5 first:pt-0 last:pb-0", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== label) {
    t3 = <span className="text-[12px] leading-[18px] text-ds-ink">{label}</span>;
    $[2] = label;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== value) {
    t4 = <span className="text-[14px] leading-5 font-semibold tracking-[-0.31px] text-black">{value}</span>;
    $[4] = value;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t2 || $[7] !== t3 || $[8] !== t4) {
    t5 = <div className={t2}>{t3}{t4}</div>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}
function Stat(t0) {
  const $ = _c(7);
  const {
    label,
    value
  } = t0;
  let t1;
  if ($[0] !== value) {
    t1 = <span className="text-[24px] leading-[26px] font-semibold tracking-[-0.48px] text-ds-ink">{value}</span>;
    $[0] = value;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== label) {
    t2 = <span className="text-[11px] leading-[13px] font-medium tracking-[-0.22px] text-[#797979]">{label}</span>;
    $[2] = label;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className="flex flex-col items-center gap-1">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}